<template>
    <div @click="onClick">
        <div class="image">
            <img :src="blogpost.image_path" class="card-img-top" alt="...">
            <div class="tags">
                <a v-for="tag in blogpost.tags" :href="'/magazin/tagged/'+tag.slug">
                    <div class="tag">{{ tag.slug }}</div>
                </a>
            </div>
        </div>
        <div class="card-body">
            <h3 class="h3 card-title mb-1">{{ blogpost.title }}</h3>
            <p class="card-text  mb-2" v-if="blogpost.head_up_text">{{ blogpost.head_up_text }}</p>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';

  @Component
  export default class BlogPostCard extends Vue {
    @Prop(Object) blogpost;
    @Prop(Array) tags;
    @Prop(String) imageUrl;
    @Prop(String) publicUrl;

    onClick() {
      window.location.href = this.blogpost.public_url;
    }

  }
</script>